import { api_url } from "../configiration/config";
import { axiosClone } from "./../axiosClone";

//get slide images
export async function getSliderImages() {
  return await axiosClone.get(`${api_url}/all/slider-images`);
}
// properties filter by area
export async function getPropertiesByArea(area){
  return await axiosClone.get(`${api_url}/properties?area=${area}`);
}
// get home headers
export async function getHomeHeaders(){
  return await axiosClone.get(`${api_url}/headers/home`);
}
//get areas that have properties

export async function getAreawithProperties(id){
  return await axiosClone.get(`${api_url}/areas/data?city=${id}`);
}